import { useApiQuery } from 'hooks/useApiQuery'
import { format } from 'date-fns'

const path = '/le-connect/licensed-establishment/reward-programs/redemptions'
const method = 'get'

interface UseGetRewardRedemptionsByLeIdParams {
  currentPage: number
  pageSize: number
  licensedEstablishmentId: number | undefined
  startDate: Date
  endDate: Date
}

const formatDate = (d: Date) => format(d, 'yyyy-MM-dd HH:mm:ss')

export const useGetRewardRedemptionsByLeId = ({
  currentPage,
  pageSize,
  licensedEstablishmentId,
  startDate,
  endDate,
}: UseGetRewardRedemptionsByLeIdParams) =>
  useApiQuery({
    path,
    method,
    queryKey: [
      path,
      licensedEstablishmentId,
      formatDate(startDate),
      formatDate(endDate),
    ],
    queryArgs: {
      currentPage,
      pageSize,
      licensedEstablishmentId,
      startDate: formatDate(startDate),
      endDate: formatDate(endDate),
    },
  })
